<template>
  <content-box class="confirm--wrap" :width="'530px'">
    <p class="title">{{ $t('userInfo.myInformation.deactivate.title') }}</p>
    <form>
      <fieldset class="field__password">
        <input type="text" autocomplete="username" hidden>
        <ui-input-text
          :id="'password'"
          :type="'password'"
          :isInputAbove="false"
          :modelError="modelError.userPw"
          :placeholder="$t('common.placeHolder.enterPassword')"
          @input="getPasswordValue"
          @onFocus="modelError.userPw = ''">
          {{ $t('userInfo.myInformation.deactivate.password.label') }}
        </ui-input-text>
      </fieldset>
      <div class="button--wrap">
        <ui-button class="btn__cancel"
                   :primary2="true"
                   @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
        <ui-button class="btn__confirm"
                   :primary="true"
                   @click="onConfirmDelete">{{ $t('common.confirm') }}</ui-button>
      </div>
    </form>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiInputText from '@/components/ui/UiInputText'
import { mapState, mapMutations } from 'vuex'
import { deactivate } from '@/api/user'
import { storageManager } from '@/libs/storage-manager'
import { removeAuthData } from '@/libs/auth-helper'

export default {
  components: {
    ContentBox,
    UiButton,
    UiInputText
  },
  name: 'deactivate',
  data () {
    return {
      model: {
        userPw: ''
      },
      modelError: {
        userPw: ''
      }
    }
  },
  computed: {
    ...mapState([
    ])
  },
  methods: {
    ...mapMutations([
      'clearAllUserData'
    ]),
    onCloseLayer () {
      this.$emit('onCloseLayer')
    },
    getPasswordValue (value) {
      this.model.userPw = value
    },
    onConfirmDelete () {
      if (!this.model.userPw.length) {
        this.modelError.userPw = 'requiredPassword'
        return false
      }
      const param = {
        ...this.model
      }
      deactivate(param).then(response => {
        this.clearAllUserData()
        storageManager.removeUserData()
        removeAuthData()
        this.$router.push({ name: 'deactivate', params: { isCompleteUser: true } })
      }).catch(err => {
        // todo: clear user data
        if (err.message === 'Wrong password') {
          this.modelError.userPw = 'wrongPassword'
        } else {
          console.error(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.confirm--wrap {
  padding: 30px;
  text-align: left;
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #2f2f2f;
  }
  .field__password {
    margin-top: 20px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    padding: 30px;
    box-sizing: border-box;

    /deep/ .input--wrap {
      .label {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #666666;
      }
      .input-element {
        width: 370px;
      }
    }
  }
  .button--wrap {
    margin-top: 40px;
    text-align: center;

    .ui-btn {
      padding: 0 30px;

      &.btn__cancel {
        margin-right: 5px;
      }
    }

    .btn__confirm {
      margin-left: 5px;
    }
  }
}
</style>
